"use client";

import { useMemo } from "react";

import type { QRProps } from "@/contexts/QREditorContext/types";
import { UseWhatsappDataResult, WhatsappTemplateTranslations } from "../types";
import { usePreviewData } from "@/features/previews/shared/hooks/usePreviewData";

/**
 * Resolves whatsapp preview data from props with QREditorContext fallback.
 */
export const useWhatsappData = (props: QRProps<"whatsapp">): UseWhatsappDataResult => {
  const { data, isInitPreview: isInitialPreview } = usePreviewData(props);

  const translations = props.previewTranslations?.["whatsapp"] as WhatsappTemplateTranslations;

  const message = useMemo(() => {
    return data?.message ?? "";
  }, [data?.message]);

  return {
    translations,
    isInitialPreview,
    data,
    message,
  };
};
